export default "__VITE_ASSET__f547e2d1__"